@if (!apps) {
  <motn-spinner></motn-spinner>
} @else {
  <motn-sort-table
    [table$]="table$"
  ></motn-sort-table>
}
